import React from 'react';
import { ChecklistItem, ChecklistItemOrigin, ChecklistItemStatus, CompanyInfo } from 'generated/credit-analysis-graphql';
import IconArrow from 'assets/svg/icon-arrow';
import Badge from 'components/commons/badge';
import useNavigation from 'hooks/navigation';
import { checklistLabel } from 'containers/documents/document-functions';
import alertIcon from '../../assets/images/alert.svg';

type DocumentStatusProps = {
    companyInfo: CompanyInfo;
};

type DocumentStatusContainerProps = {
    checklistItem: ChecklistItem;
    index: number;
    label?: string;
    className?: string;
    goToSendAllowedDocuments(): void;
};

const DocumentStatusContainer: React.FC<DocumentStatusContainerProps> = ({ checklistItem, index, label, className = '', goToSendAllowedDocuments }) => (
        <div key={`bizon-liveness-steps-${index}`}>
            <div className="content">
                <p className={`body-1 ${className}`} >{label}</p>

                <div className="d-flex">
                    {checklistItem.status !== ChecklistItemStatus.Pending
                        ? (
                            <Badge variant="green">
                                enviado
                            </Badge>
                        )
                        : (
                            <>
                                <Badge variant="tangerine">
                                    pendente
                                </Badge>
                                <button
                                    onClick={goToSendAllowedDocuments}
                                    className="btn-send"
                                    type="button"
                                >
                                    <span>enviar</span>
                                    <IconArrow />
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
            {checklistItem.status === ChecklistItemStatus.Pending && checklistItem.externalNotification && (
                <div className="notification">
                    <div>
                        <img src={alertIcon} alt="Icone de alerta" className="c-alert__icon" />
                    </div>
                    <p>
                        {checklistItem.observation}
                    </p>
                </div>
            )}
        </div>
);

const DocumentStatus: React.FC<DocumentStatusProps> = ({ companyInfo }) => {
    const { checklist, signers } = companyInfo;
    const { goToSendCompanyDocuments, goToSendPartnerDocuments } = useNavigation();

    return (
        <>
            <div className={"bizon-liveness-steps-info mt-5 mb-3"}>
                {
                    checklist.items.filter(i => i.origin === ChecklistItemOrigin.UploadForm).map((checklistItem, index) => (
                        <DocumentStatusContainer
                            key={`doc-${index}`}
                            label={checklistLabel[checklistItem.allowedDocuments[0]].label}
                            checklistItem={checklistItem}
                            goToSendAllowedDocuments={() => goToSendCompanyDocuments(
                                checklistItem.allowedDocuments,
                                checklistLabel[checklistItem.allowedDocuments[0]].type
                            )}
                            index={index}
                        />
                    ))
                }
            </div>
            {(signers.length > 0) && (
                <div className="bizon-liveness-steps-info mt-5 mb-3">
                    <h3>{signers.some(s => !s.checklist.isCompleted)
                        ? 'envie também o documento dos sócios encontrados'
                        : 'documento dos sócios encontrados'}</h3>
                    {signers.map((signer, signerIndex) =>
                        signer.checklist.items.filter(i => i.origin === ChecklistItemOrigin.UploadForm).map((checklistItem, index) => {
                            const hasItems = signer.checklist.items.length > 1;
                            return <>
                                {(hasItems && index === 0) && <div><p className="body-1">{signer.name}</p></div>}
                                <DocumentStatusContainer
                                    key={`doc-signer-${index}`}
                                    label={hasItems
                                        ? `${checklistLabel[checklistItem.allowedDocuments[0]].label}`
                                        : signer.name
                                    }
                                    checklistItem={checklistItem}
                                    goToSendAllowedDocuments={() => goToSendPartnerDocuments(
                                        checklistItem.allowedDocuments,
                                        checklistLabel[checklistItem.allowedDocuments[0]].type,
                                        signer)}
                                    index={index + signerIndex}
                                    className={(hasItems) ? 'ml-4' : ''}
                                />
                            </>
                        })
                    )}
                </div>
            )}
        </>
    );
};

export default DocumentStatus;
